function hidePositionEmployerController(
  $scope,
  $modal,
  $log,
  logger,
  HidePositionEmployerApi
) {
  const resetModalOptions = () => {
    $scope.modalInstance = undefined
    $scope.options = {
      alreadyApplied: {
        position: 1,
        selected: false,
        label: `Hide this opportunity, I'm interested but have already applied within the last 6 months.`,
        reason: `Position Already Applied`,
      },
      hideOpportunity: {
        position: 2,
        selected: false,
        label: 'Hide this opportunity specifically, this team is not for me.',
        reason: `Position Not For Me`,
      },
      hideEmployer: {
        position: 3,
        selected: false,
        label:
          'Hide this and all future opportunities at this firm, this employer is not for me.',
        reason: `Employer Not For Me`,
      },
    }
  }

  const errorHandler = errorResponse => {
    $log.error(errorResponse)
    logger.notify('error', `something went wrong: ${errorResponse.statusText}`)
  }

  const successHandler = (message, data, callback) => {
    logger.notify('success', message)
    callback({position: data})
  }

  const hidePosition = modalData => {
    let message =
      'This position is now hidden and will appear under the hidden positions section'

    if ($scope.page === 'matches') {
      message =
        'This match is now hidden and can be found by switching to the Hidden matches view'
    } else if ($scope.page === 'in-house') {
      message =
        'This position is now hidden and can be found by switching to the Hidden positions view'
    } else if ($scope.page === 'opportunities') {
      message =
        'This team is now hidden and can be found by switching to the Hidden teams view'
    }

    HidePositionEmployerApi.hidePosition(
      modalData.userId,
      modalData.id,
      modalData.option.reason
    )
      .then(() => successHandler(message, modalData, $scope.onPositionHide))
      .catch(errorHandler)
  }

  const hideEmployer = modalData => {
    const message =
      'The employer is now hidden for you and will be not be shown in the future'

    HidePositionEmployerApi.hideEmployer(modalData.userId, modalData.employerId)
      .then(() => successHandler(message, modalData, $scope.onEmployerHide))
      .catch(errorHandler)
  }

  const setModalData = modalData => {
    $scope.modalData = modalData
  }

  const modalSuccessHandler = modalData => {
    const options = $scope.options

    if (
      options.alreadyApplied.selected ||
      $scope.options.hideOpportunity.selected
    ) {
      modalData.option = options.alreadyApplied.selected
        ? options.alreadyApplied
        : options.hideOpportunity
      hidePosition(modalData)
    } else if (options.hideEmployer.selected) {
      modalData.option = options.hideEmployer
      hideEmployer(modalData)
    }
  }

  const modalOpenHandler = (jobInfo, event) => {
    stopEvents(event)
    resetModalOptions()
    setModalData(jobInfo)

    $scope.modalInstance = $modal.open({
      backdrop: 'static',
      templateUrl: 'modal-template-position-hide-options',
      scope: $scope,
    })

    return $scope.modalInstance.result.then(modalSuccessHandler)
  }

  $scope.modalOpenHandler = modalOpenHandler
  $scope.closeModal = () => $scope.modalInstance.dismiss('cancel')
  $scope.hidePositionOrEmployer = () => {
    const options = $scope.options
    const isAnyOptionSelected = _.some(options, option => option.selected)

    if (!isAnyOptionSelected) {
      logger.notify(
        'warning',
        "Please select your choice before clicking 'Hide'"
      )
      return
    }

    $scope.modalInstance.close($scope.modalData)
  }
}

const stopEvents = event => {
  if (event) {
    event.preventDefault()
    event.stopPropagation()
  }
}

export {hidePositionEmployerController}



// WEBPACK FOOTER //
// ./scripts/shared/directives/modal-hide-positions-employer/hide-position-employer.ctrl.js